import React from 'react';
import PropTypes from 'prop-types';

import EggsIcon from 'components/Icons/EggIcon';
import FishIcon from 'components/Icons/FishIcon';
import MilkIcon from 'components/Icons/MilkIcon';
import SoyaIcon from 'components/Icons/SoyaIcon';
import LupinIcon from 'components/Icons/LupinIcon';
import NutsIcon from 'components/Icons/AlmondIcon';
import HalalIcon from 'components/Icons/HalalIcon';
import VeganIcon from 'components/Icons/VeganIcon';
import CeleryIcon from 'components/Icons/CeleryIcon';
import GlutenIcon from 'components/Icons/GlutenIcon';
import KosherIcon from 'components/Icons/KosherIcon';
import SesameIcon from 'components/Icons/SesameIcon';
import PeanutsIcon from 'components/Icons/PeanutIcon';
import MustardIcon from 'components/Icons/MustardIcon';
import MolluscsIcon from 'components/Icons/MolluscIcon';
import SulphurIcon from 'components/Icons/SulphiteIcon';
import VegetarianIcon from 'components/Icons/VegetarianIcon';
import CrustaceansIcon from 'components/Icons/CrustaceansIcon';
import AlcoholIcon from 'components/Icons/AlcoholIcon';
import PorkIcon from 'components/Icons/PorkIcon';
import GlutenFreeIconIcon from 'components/Icons/GlutenFreeIcon';
import HighSodiumIcon from 'components/Icons/HighSodiumIcon';
import FssaiVeganIcon from 'components/Icons/FssaiVeganIcon';
import FssaiVegetarianIcon from 'components/Icons/FssaiVegetarianIcon';
import FssaiNonVegetarianIcon from 'components/Icons/FssaiNonVegetarianIcon';

const icons = {
  EggsIcon,
  FishIcon,
  MilkIcon,
  SoyaIcon,
  LupinIcon,
  NutsIcon,
  HalalIcon,
  VeganIcon,
  CeleryIcon,
  GlutenIcon,
  KosherIcon,
  SesameIcon,
  PeanutsIcon,
  MustardIcon,
  MolluscsIcon,
  SulphurIcon,
  VegetarianIcon,
  CrustaceansIcon,
  AlcoholIcon,
  PorkIcon,
  GlutenFreeIconIcon,
  HighSodiumIcon,
  FssaiVeganIcon,
  FssaiVegetarianIcon,
  FssaiNonVegetarianIcon,
};

const AllergenIcon = ({ allergenName, width, height, fill, className, isIndianVenue, active = true }) => {
  let Icon;

  switch (allergenName) {
    case 'sesame_seeds':
      Icon = icons.SesameIcon;
      break;
    case 'sulphur_dioxide':
      Icon = icons.SulphurIcon;
      break;
    case 'gluten_free':
      Icon = icons.GlutenFreeIconIcon;
      break;
    case 'high_sodium':
      Icon = icons.HighSodiumIcon;
      break;
    case 'non_vegetarian':
      if (!isIndianVenue) return null;
      Icon = icons.FssaiNonVegetarianIcon;
      break;
    case 'vegetarian':
      Icon = isIndianVenue ? icons.FssaiVegetarianIcon : icons.VegetarianIcon;
      break;
    case 'vegan':
      Icon = isIndianVenue ? icons.FssaiVeganIcon : icons.VeganIcon;
      break;
    default: {
      // Take the allergen name and convert it to title case to fetch correct icon dynamically.
      if (allergenName.indexOf('nut_') === 0) allergenName = 'nuts';
      if (allergenName.indexOf('gluten_') === 0) {
        allergenName = allergenName.split('_')[0];
      }
      Icon = icons[`${allergenName.charAt(0).toUpperCase()}${allergenName.slice(1)}Icon`];
    }
  }
  return <Icon width={width} height={height} fill={fill} className={className} active={active} />;
};

AllergenIcon.propTypes = {
  allergenName: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
  className: PropTypes.string,
  isIndianVenue: PropTypes.bool,
  active: PropTypes.bool,
};

export default AllergenIcon;
